var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
		(!_vm.mobileOnly && !_vm.desktopOnly) ||
			(_vm.mobileOnly && _vm.mobile) ||
			(_vm.desktopOnly && !_vm.mobile)
	)?_c('div',{class:_vm.mobile ? _vm.mobileClass : _vm.desktopClass,style:(_vm.mobile ? _vm.mobileStyle : _vm.desktopStyle)},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }